import Header from '../../../Components/Header'
import { Helmet } from 'react-helmet'
import TableLayout from './TableLayout'

const MeltingRequestList = () => {

    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
            <Helmet>
                <title>melting-request-list</title>
            </Helmet>
            <Header />
            <TableLayout />
        </div>
    )
}

export default MeltingRequestList